import { demoFile, feature, component, story, CLICK } from 'system/demo';
import { VideoVotingListFeature, VideoVotingListScreen } from '../video-voting-list';
import { AdminStructure } from 'structure/admin';

demoFile('open-modules/zdf/feature/admin/video-voting-list');

feature('Video Voting List', {
    structureKey: 'admin',
    config: AdminStructure.receivesConfigDefaults,
    features: { videovotinglist: true },
    state: {
        collections: { videoVoting: [{ key: 'v1', name: 'Vote One' }] },
        modulePublic: { videovoting: { all: { v1: { key: 'v1', name: 'Vote One' } } } },
        roles: ['Editorial']
    }
});

component('VideoVotingListScreen', VideoVotingListScreen);
